import { styled } from '@mui/material/styles'
import { themeBorderRadius, themeColor, themeSpacing } from 'eezy-components'
import { css } from 'styled-components'

export const Container = styled('div')`
  .warning-container {
    border: 1px solid ${themeColor('warning', 'main')};
    margin-top: ${themeSpacing(3)};
  }
`

export const RejectionReasonList = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${themeSpacing(0.5)};
`

export const Image = styled('img')`
  width: 75%;
  height: 75%;
  object-fit: cover;
`

export const LoadingContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${themeSpacing(8)};
`

export const FormLoadingContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${themeSpacing(50)};
`

export const FooterContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: ${themeSpacing(3)};
  padding: ${themeSpacing(2)} 0;

  span {
    margin-left: ${themeSpacing(0.5)};
  }

  .close-your-account-link {
    color: ${themeColor('primary', 'main')};

    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }
  }
`

export const FormContainer = styled('div')<{ $isMobile: boolean }>`
  padding: 0 ${themeSpacing(18)};

  ${props =>
    props.$isMobile
      ? css`
          padding: 0;
        `
      : ''}
`

export const FormWrapper = styled('div')<{ $isMobile: boolean }>`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${themeSpacing(3)};

  ${props =>
    props.$isMobile
      ? css`
          grid-template-columns: 1fr;
        `
      : ''}
`

export const InfoSection = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${themeSpacing(2)};

  a {
    cursor: pointer;
  }
`

export const FormSection = styled('div')`
  padding: ${themeSpacing(2)};
  background-color: #fff;
  border-radius: ${themeBorderRadius('medium')};
`

export const FormRow = styled('div')`
  display: flex;
  flex-direction: row;
  gap: ${themeSpacing(1)};
  margin: ${themeSpacing(2)} 0;

  svg {
    height: ${themeSpacing(3.5)};
    width: ${themeSpacing(3.5)};
    margin-left: ${themeSpacing(1.5)};
  }
`

export const FormSeparator = styled('div')`
  height: ${themeSpacing(2)};
`

export const ErrorWrapper = styled('div')`
  margin-top: ${themeSpacing(0.25)};
`
